import { render, staticRenderFns } from "./ItemTypeInspector.vue?vue&type=template&id=1af51a94&scoped=true"
import script from "./ItemTypeInspector.vue?vue&type=script&lang=ts"
export * from "./ItemTypeInspector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af51a94",
  null
  
)

export default component.exports